var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon4K(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    "data-name": "Calque 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 375",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_2",
    "data-name": "Calque 2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M175,118.8h3.1v96.9H118.7C137.5,184.4,159.4,150,175,118.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.5,0H62.5A62.65,62.65,0,0,0,0,62.5v250A62.65,62.65,0,0,0,62.5,375h375A62.65,62.65,0,0,0,500,312.5V62.5A62.65,62.65,0,0,0,437.5,0Zm-200,243.8h-25v34.4H181.3V243.8H90.7V215.7c25-40.6,50-84.4,75-121.9h46.8V215.7h25Zm134.4,34.3-59.4-81.2-18.8,21.9v59.4H259.3V93.8h34.4v84.4h3.1l71.9-84.4h37.5L337.5,175l75,103.1Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon4K);
export default __webpack_public_path__ + "static/media/icon-4k.cb56c53998f9dec40ffeecca11ff1028.svg";
export { ForwardRef as ReactComponent };